import React from 'react';

const UserLocationTable = () => {

    const DATA = [
        {
            country: 'United States',
            percentage: 28.18
        },
        {
            country: 'United Kingdom',
            percentage: 6.12
        },
        {
            country: 'Germany',
            percentage: 3.78
        },
        {
            country: 'Poland',
            percentage: 3.64
        },
        {
            country: 'Indonesia',
            percentage: 3.48
        },
        {
            country: 'Brazil',
            percentage: 3.16
        },
        {
            country: 'Spain',
            percentage: 3.03
        },
        {
            country: 'Turkey',
            percentage: 2.88
        },
        {
            country: 'Italy',
            percentage: 2.62
        },
        {
            country: 'Russia',
            percentage: 2.55
        },
        {
            country: 'Australia',
            percentage: 2.49
        },
        {
            country: 'Canada',
            percentage: 2.41
        },
        {
            country: 'Philippines',
            percentage: 2.29
        },
        {
            country: 'Mexico',
            percentage: 2.26
        },
        {
            country: 'India',
            percentage: 2.16
        }
    ]

    return (
        <div className="bg-white shadow-md rounded-lg p-6 max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold mb-4">Muzify users (Organic)</h2>
            <div className="overflow-x-auto">
                <table className="w-full text-sm text-left text-gray-500">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th className="px-6 py-3">Country</th>
                            <th className="px-6 py-3">Percentage</th>
                        </tr>
                    </thead>
                    <tbody>
                        {DATA.map((data, index) => (
                            <tr key={index} className="bg-white border-b hover:bg-gray-50">
                                <td className="px-6 py-4 font-medium text-gray-900">{data.country}</td>
                                <td className="px-6 py-4">{data.percentage}%</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default UserLocationTable;
